<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="faq-page">
    <!-- HERO -->
    <section class="page-hero">
      <div class="page-hero-inner">
        <div class="section-label">FAQ</div>
        <h1 class="page-title">常見問題</h1>
        <p class="page-sub">
          我們整理了最常見的問題，希望能幫助您更了解我們的產品與服務
        </p>
      </div>
    </section>

    <!-- FAQ -->
    <section class="faq-section">
      <div class="faq-inner">
        <div class="faq-list">
          <div
            v-for="(faq, i) in faqs"
            :key="i"
            class="faq-item"
            :class="{ open: openFaq === i }"
          >
            <button class="faq-q" @click="toggleFaq(i)">
              <span>{{ faq.q }}</span>
              <span class="faq-icon">{{ openFaq === i ? "−" : "+" }}</span>
            </button>
            <div class="faq-a" v-show="openFaq === i">
              <p>{{ faq.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="faq-cta">
      <div class="cta-inner">
        <h2>還有其他問題？</h2>
        <p>歡迎直接聯絡我們，我們的專業團隊將為您解答</p>
        <router-link to="/contact" class="btn-primary">聯絡我們</router-link>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-inner">
        <p>© 2026 綠憩植研 Green Rich Geam. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";

const openFaq = ref(null);

const toggleFaq = (i) => {
  openFaq.value = openFaq.value === i ? null : i;
};

const faqs = [
  {
    q: "如何判斷何時需要加水？",
    a: "透過水位視窗可直觀判斷水位高低，當水位降至下標線時即可補水。一般情況下，每月補水一至兩次即可，非常簡單方便。",
  },
  {
    q: "這套系統真的不用施肥嗎？",
    a: "是的，可替換營養模組已含有植物所需的均衡養分。一般每 3-6 個月更換一次模組即可，不需要額外施肥，大幅降低養護難度。",
  },
  {
    q: "植物枯萎了有固定或諮詢嗎？",
    a: "我們提供購買後 30 天內的植物健康保固服務，若發現問題可聯絡客服，由專業人員提供遠端診斷與換植服務。",
  },
  {
    q: "可以更換植物嗎？",
    a: "可以的！我們的容器系統設計為模組化，支援植物更換。您可以依季節或個人喜好更換不同品種的植栽，豐富居家風格。",
  },
  {
    q: "適合放在辦公室或室內嗎？",
    a: "我們精選的植栽品種均耐陰、耐乾，非常適合室內辦公環境。同時也提供企業植栽租賃服務，包含定期維護，讓您完全免去照護煩惱。",
  },
  {
    q: "運送範圍和費用是多少？",
    a: "目前提供全台配送服務。台灣本島運費為 NT$ 150，訂單滿 NT$ 2,000 免運費。偏遠地區及離島可能需要額外運費，詳情請聯絡客服。",
  },
  {
    q: "可以大量訂購或企業採購嗎？",
    a: "當然可以！我們提供企業採購、大量訂購的專屬優惠方案。請透過聯絡表單告知您的需求，我們的業務團隊將為您報價。",
  },
  {
    q: "如何申請植栽租賃服務？",
    a: "請填寫聯絡表單選擇「企業植栽租賃」類別，或直接致電客服。我們將安排專人到府評估空間，提供最適合的租賃方案。",
  },
];
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.faq-page {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

/* HERO */
.page-hero {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
}

.page-hero-inner {
  max-width: 600px;
  margin: 0 auto;
}

.section-label {
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 16px;
}

.page-title {
  font-size: 3em;
  font-weight: 600;
  margin-bottom: 16px;
}

.page-sub {
  font-size: 1.1em;
  opacity: 0.85;
  line-height: 1.7;
}

/* FAQ */
.faq-section {
  max-width: 800px;
  margin: 80px auto;
  padding: 0 40px;
}

.faq-inner {
  width: 100%;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
}

.faq-item.open {
  box-shadow: 0 4px 16px rgba(78, 123, 79, 0.15);
}

.faq-q {
  width: 100%;
  padding: 20px 24px;
  background: white;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1c2b1a;
  text-align: left;
  transition: all 0.3s;
  font-family: inherit;
}

.faq-q:hover {
  color: #4e7b4f;
}

.faq-item.open .faq-q {
  color: #4e7b4f;
  border-bottom: 1px solid #eaf2e0;
}

.faq-icon {
  font-size: 20px;
  color: #4e7b4f;
  flex-shrink: 0;
  margin-left: 16px;
  font-weight: 300;
}

.faq-a {
  padding: 20px 24px;
  background: #fafefa;
}

.faq-a p {
  color: #6b7f68;
  line-height: 1.8;
  font-size: 15px;
}

/* CTA */
.faq-cta {
  background: #eaf2e0;
  padding: 80px 40px;
  text-align: center;
  margin-top: 40px;
}

.cta-inner {
  max-width: 500px;
  margin: 0 auto;
}

.cta-inner h2 {
  font-size: 2em;
  color: #1c2b1a;
  margin-bottom: 12px;
}

.cta-inner p {
  color: #6b7f68;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.7;
}

.btn-primary {
  padding: 14px 40px;
  background: #4e7b4f;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
  font-weight: 600;
}

.btn-primary:hover {
  background: #2d5016;
  transform: translateY(-2px);
}

/* FOOTER */
.footer {
  background: #1c2b1a;
  color: #9baa97;
  text-align: center;
  padding: 40px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 2em;
  }

  .faq-section {
    margin: 40px auto;
    padding: 0 20px;
  }

  .faq-q {
    font-size: 14px;
    padding: 16px 20px;
  }
}
</style>
